export function getSupabaseClientConfig() {
  return {
    url: process.env.NEXT_PUBLIC_SUPABASE_URL,
    key: process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY,
  };
}

export function getRequiredSupabaseClientConfig(): { url: string; key: string } {
  const config = getSupabaseClientConfig();

  if (!config.url || !config.key) {
    throw new Error(
      'Missing Supabase client env vars. Expected NEXT_PUBLIC_SUPABASE_URL and NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY.'
    );
  }

  return {
    url: config.url,
    key: config.key,
  };
}